import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../models/api.models';

@Injectable({
  providedIn: 'root'
})
export class BaseApiService {
  protected baseUrl = environment.api.baseUrl;
  protected adminBaseUrl = environment.api.adminBaseUrl;
  protected gameBaseUrl = environment.api.gameBaseUrl;

  constructor(protected http: HttpClient) {}

  /**
   * Generic POST request for admin endpoints
   */
  protected adminPost<T>(endpoint: string, body: any): Observable<ApiResponse<T>> {
    return this.http.post<ApiResponse<T>>(`${this.adminBaseUrl}${endpoint}`, body);
  }

  /**
   * Generic POST request for game endpoints
   */
  protected gamePost<T>(endpoint: string, body: any): Observable<ApiResponse<T>> {
    return this.http.post<ApiResponse<T>>(`${this.gameBaseUrl}${endpoint}`, body);
  }

  /**
   * Generic GET request
   */
  protected get<T>(endpoint: string, params?: HttpParams): Observable<ApiResponse<T>> {
    return this.http.get<ApiResponse<T>>(`${this.baseUrl}${endpoint}`, { params });
  }

  /**
   * Generic PUT request
   */
  protected put<T>(endpoint: string, body: any): Observable<ApiResponse<T>> {
    return this.http.put<ApiResponse<T>>(`${this.baseUrl}${endpoint}`, body);
  }

  /**
   * Generic DELETE request
   */
  protected delete<T>(endpoint: string): Observable<ApiResponse<T>> {
    return this.http.delete<ApiResponse<T>>(`${this.baseUrl}${endpoint}`);
  }

  /**
   * Upload file with base64 data
   */
  protected uploadFile<T>(endpoint: string, fileData: any): Observable<ApiResponse<T>> {
    return this.http.post<ApiResponse<T>>(`${this.baseUrl}${endpoint}`, fileData);
  }
}
